import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { Metrics } from '../dataObjects/MailgunMetricsResponse';

interface totalStatsProps {
    metrics?: Metrics;
}

const EmailServerTotalStats = (props: totalStatsProps) => {

    const formatNumberShort = (number:number) => {
        return Intl.NumberFormat('en',
            {
                notation: 'compact',
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        ).format(number);
    }

    return (
        <>
            <Stack direction="row" spacing={1} marginBottom={3} marginRight={2}>
                <Grid item xs={3}>
                    <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                        <CardContent>
                            <Typography color={'text.secondary'} variant="subtitle2">
                                {props.metrics?.deliveredCount && formatNumberShort(props.metrics?.deliveredCount)}
                                &nbsp;/&nbsp;{props.metrics?.totalCount && formatNumberShort(props.metrics?.totalCount)}
                            </Typography>
                            <Typography color={'text.secondary'} variant="subtitle2" gutterBottom>
                                Delivered
                            </Typography>
                            <Typography variant="h6" component="p">
                                {props.metrics?.deliveredPercent}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={3}>
                    <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                        <CardContent>
                            <Typography color={'text.secondary'} variant="subtitle2">
                                {props.metrics?.failedCount && formatNumberShort(props.metrics?.failedCount)}
                                &nbsp;/&nbsp;{props.metrics?.totalCount && formatNumberShort(props.metrics?.totalCount)}
                            </Typography>
                            <Typography color={'text.secondary'} variant="subtitle2" gutterBottom>
                                Failed
                            </Typography>
                            <Typography variant="h6" component="p" color="error">
                                {props.metrics?.failedPercent}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={3}>
                    <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                        <CardContent>
                            <Typography color={'text.secondary'} variant="subtitle2">
                                {props.metrics?.suppressedTotalCount && props.metrics?.suppressedTotalCount}
                                &nbsp;/&nbsp;{props.metrics?.totalCount && formatNumberShort(props.metrics?.totalCount)}
                            </Typography>
                            <Typography color={'text.secondary'} variant="subtitle2" gutterBottom>
                                Suppressed
                            </Typography>
                            <Typography variant="h6" component="p">
                                {props.metrics?.suppressedPercent}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Stack>
        </>
       
    );
}

export default EmailServerTotalStats 